/**
 * Aggregate rating stats from a list of Marketplace reviews.
 *
 * @param {Array<{ attributes?: { rating?: number } }>} reviews
 * @returns {{ average: number|null, count: number, distribution: number[] }}
 *   distribution[0]=5★ count … distribution[4]=1★ count
 */
export const computeReviewSummary = (reviews = []) => {
  const distribution = [0, 0, 0, 0, 0];
  let sum = 0;
  let count = 0;

  reviews.forEach(review => {
    const rating = review?.attributes?.rating;
    if (typeof rating !== 'number' || rating < 1 || rating > 5) {
      return;
    }
    const rounded = Math.round(rating);
    distribution[5 - rounded] += 1;
    sum += rating;
    count += 1;
  });

  if (count === 0) {
    return { average: null, count: 0, distribution };
  }

  return {
    average: Math.round((sum / count) * 10) / 10,
    count,
    distribution,
  };
};
